module.exports = __webpack_public_path__ + "img/expodecor_paris_pavement.8c733ad4.jpg";